import { Action, createReducer, on } from '@ngrx/store';
import { PartyRoleRelationship } from '@wdx/clmi/clmi-swagger-gen';
import { CrudState, CrudStateObject } from '@wdx/clmi/api-services/models';
import * as personalConnectionsActions from './personal-connections.actions';

export interface State {
    personalConnections: CrudStateObject<PartyRoleRelationship>;
}

export const initialState: State = {
    personalConnections: {},
};

const reducerSetup = createReducer(
    initialState,

    on(
        personalConnectionsActions.getForParty,
        (state, props): State => ({
            ...state,
            personalConnections: {
                ...state.personalConnections,
                [props.partyId]: {
                    ...(state.personalConnections[props.partyId] ||
                        ({} as CrudState<PartyRoleRelationship>)),
                    isLoadingList: true,
                    hasLoadingListError: false,
                },
            },
        }),
    ),

    on(
        personalConnectionsActions.getForPartySuccess,
        (state, props): State => ({
            ...state,
            personalConnections: {
                ...state.personalConnections,
                [props.partyId]: {
                    ...state.personalConnections[props.partyId],
                    isLoadingList: false,
                    hasLoadingListError: false,
                    list: props.relationships,
                },
            },
        }),
    ),

    on(
        personalConnectionsActions.getForPartyFailure,
        (state, props): State => ({
            ...state,
            personalConnections: {
                ...state.personalConnections,
                [props.partyId]: {
                    ...state.personalConnections[props.partyId],
                    isLoadingList: false,
                    hasLoadingListError: true,
                },
            },
        }),
    ),
);

export function reducer(state: State | undefined, action: Action) {
    return reducerSetup(state, action);
}
